module.exports = __webpack_public_path__ + "img/go10.00ae8568.png";